import "ckeditor5/ckeditor5.css";
import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import EditorToolbar, {
  formats,
  modules,
} from "../../cpn/common/editorToolbar";
import { parseTypeWithDefaultValue } from "../../utils/parseType";

import PageNotFound from "../../pages/notfound";
import { Conditions } from "../../utils/Conditions";
import {
  Bool,
  Char,
  DataEmail,
  DataPhone,
  DateInput,
  DateTimeInput,
  Decimal,
  FileImage,
  Int,
  Text,
  TimeInput,
  Varchar,
} from "../inputs";
import { param } from "jquery";

const COMPONENT = ({ isData = {}, isModal, handleCloseModal }) => {
  const { isUrl, setRefreshPage, pageId } = isData;
  const dispatch = useDispatch();
  const _token = localStorage.getItem("_token");
  const { project_id, version_id, url, id_str } = useParams();
  let navigate = useNavigate();
  const { proxy, pages, lang, functions, socket, database, auth } = useSelector(
    (state) => state
  );
  const [api, setApi] = useState({});
  const [tables, setTables] = useState([]);
  const [fields, setFields] = useState([]);
  const [errors, setErrors] = useState([]);
  const [data, setData] = useState({});
  const [relatedTables, setRelatedTables] = useState([]);
  const [isDisplayFields, setDisplayFields] = useState([]);
  const [defaultValues, setDefaultValues] = useState([]);

  const [page, setPage] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [refreshForm, setRefreshForm] = useState(0);
  const checkIdStr = id_str ? id_str : isUrl;
  const refID = useRef({});
  const _table = functions.findTableByUrl(page, id_str ? id_str : isUrl, "add");

  // console.log(299, fields);
  const goToHomePage = () => {
    // navigate(`/page/${url}`);
    navigate(-1);
  };
  const inputs = document.querySelectorAll(
    'input[type="number"], input[type="text"], textarea'
  );

  // what the heck is this thinh
  inputs.forEach((input) => {
    input.addEventListener("keydown", function (e) {
      if (e.keyCode === 13) {
        // submit();
      }
    });
  });

  const [phoneError, setPhoneError] = useState(false);
  const handlePhoneError = (error) => {
    setPhoneError(error);
  };
  const [emailError, setEmailError] = useState(false);
  const handleEmailError = (error) => {
    setEmailError(error);
  };
  // console.log(pages)
  const [currentPage, setCurrentPage] = useState(undefined);

  useEffect(() => {
    const result = functions.findPageById(pages, `${pageId ? pageId : url}`);
    if (result?.component.length > 0) {
      setPage(result);
    }
    let findId = null;

    result?.component.map((item) => {
      if (item.name === "grid" && item.children && item.children.length > 0) {
        const foundChild = item?.children.find(
          (child) => child?.props?.buttons?.add?.api?.api_id === checkIdStr
        );
        if (foundChild) {
          findId = foundChild?.id;
        }
      } else if (item?.props?.buttons?.add?.api?.api_id === checkIdStr) {
        findId = item.id;
      }
    });

    if (findId) {
      const currentPage = pages.find((p) => p.block === findId)?.component?.[0]
        ?.children;

      if (currentPage) {
        setCurrentPage(currentPage);
      }
    }
    // const currentPage = pages.find(
    //   (p) =>
    //     p.block ===
    //     result?.component.find(
    //       (item) => item?.props?.buttons?.add?.api?.api_id === id_str
    //     )?.id
    // )?.component?.[0]?.children;

    // setCurrentPage(currentPage);
  }, [pages, isUrl]);

  useEffect(() => {
    if (currentPage) {
      (async () => {
        const res = await fetch(
          `${proxy()}/apis/api/${checkIdStr}/input_info`,
          {
            headers: {
              Authorization: _token,
            },
          }
        );
        const json_res = await res.json();

        const { success, api, relatedTables, data } = json_res;

        if (success) {
          const fields = [];
          if (currentPage) {
            currentPage.map(({ props: { field_id, ...props } }) => {
              const found_field = data.body?.find(({ id }) => field_id === id);
              if (found_field) {
                fields.push({ ...found_field, ...props });
              }
            });
            setDisplayFields(data.display_fields);
            setFields(fields);
            setTables(data.tables);
          }
        }
        setIsFetching(false);
      })();
    }
  }, [currentPage]);
  const result = functions.findPostApi(page);

  let api_method = null;
  let PUBLIC_API = useRef({});

  const changeTrigger = (field, value, index, newField) => {
    setData((prev) => {
      const newData = { ...prev };
      if (value === "true") {
        newData[field.fomular_alias] = true;
      } else if (value === "false") {
        newData[field.fomular_alias] = false;
      } else {
        if (typeof value === "string") {
          value = value.trim();
        }
        if (!Array.isArray(field)) {
          if (!Array.isArray(value)) {
            newData[field.fomular_alias || field] = value;
          } else {
            if (!newData[field.fomular_alias || field]) {
              newData[field.fomular_alias || field] = value;
            } else {
              newData[field.fomular_alias || field] = [
                ...newData[field.fomular_alias || field],
                ...value,
              ];
            }
          }
        } else {
          if (!newData[value.id]) {
            newData[value.id] = field;
            PUBLIC_API.current[value.id] = value;
          } else {
            if (field && field.length > 0) {
              if (!newData[value.id]) {
                newData[value.id] = [];
              }
              // newData[value.id] =[
              //   ...newData[value.id],
              //   ...field
              // ]
              // const fieldIds = field.map((item) => item._id);
              // const newDataIds = newData[value.id].map((item) => item._id);
              // field.map((item) => {
              //   if (!newDataIds.includes(item._id)) {
              //     newData[value.id].push(item);
              //   }
              // });
              // newData[value.id] = newData[value.id].filter((item) =>
              //   fieldIds.includes(item._id)
              // );

              field.map((f) => {
                const isDuplicate = newData[value.id].some(
                  (item) =>
                    item._id === f._id &&
                    item?.deliveryDetailId === f?.deliveryDetailId
                );

                if (!isDuplicate) {
                  newData[value.id].push(f);
                }
              });
            } else {
              // newData[value.id] = [];
            }
          }
          // newData[value.id] = [...field];
        }
      }
      fields.map((data) => {
        if (data.api) {
          data.api?.api_detail?.body.map((item) => {
            const findFields = database.fields.find(
              (field) => field.id === item
            );
            if (findFields?.id === field?.id) {
              newData[field.fomular_alias] = value;
            }
          });
          PUBLIC_API.current[data.id] = data;
        }
      });
      if (refID && Object.values(refID.current).length > 0) {
        newData[value.id] = newData[value.id].filter(
          ({ _id }) => _id !== refID.current
        );
      }
      refID.current = {};
      return newData;
    });
  };

  const nullCheck = (data) => {
    let valid = true;

    for (let i = 0; i < fields.length; i++) {
      const field = fields[i] || {};

      const { NULL, fomular_alias, title: { visible } = {} } = field;
      if (!NULL && visible) {
        if (
          data[fomular_alias] == null ||
          data[fomular_alias] == undefined ||
          data[fomular_alias] === ""
        ) {
          valid = false;
        }
      }
    }
    return { valid };
  };

  const [isLoading, setIsLoading] = useState(false);
  const loadingAdd = useRef(true);
  const showError = (title, text) => {
    Swal.fire({
      title: title,
      text: text,
      icon: "error",
      showConfirmButton: true,
    });
  };
  const handleAPIErrors = (res) => {
    const {
      primaryConflict,
      foreignConflict,
      typeError,
      conflictedPrimaryKeys,
    } = res;
    if (primaryConflict && foreignConflict)
      return showError(lang["faild"], lang["erorr pk fk"]);
    if (primaryConflict)
      return showError(
        lang["faild"],
        `${lang["erorr pk"]}: ${Object.keys(conflictedPrimaryKeys).join(", ")}`
      );
    if (foreignConflict) return showError(lang["faild"], lang["erorr fk"]);
    if (typeError.status)
      return showError(
        lang["faild"],
        `${lang["fail.add"]} ${
          typeError.message?.[0].field_name
        } ${typeError.message?.[0].validate.reason.toLowerCase()}`
      );
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    submit(event);
  };
  const [isToggleModal, setIsToggleModal] = useState({
    state: false,
    content: "",
  });

  if (isToggleModal.state) {
    Swal.fire({
      title: lang["fail"],
      html: isToggleModal.content.replace(/\n/g, "<br>"),
      icon: "error",
      showConfirmButton: true,
      timer: 0,
    });

    setIsToggleModal({ state: false, content: "" });
  }

  const submit = async (event) => {
    if (event) {
      event.preventDefault();
    }

    // const {
    //   api: {
    //     api_detail: { params, body_detail },
    //   },
    // } = PUBLIC_API.current;
    const mappedData = {
      ...data,
    };

    const mapping_fields = [];

    const data_keys = Object.keys(mappedData);

    const API_PAYLOAD = {};

    const { tables: TABLES, fields: FIELDS } = database;
    for (const index in PUBLIC_API.current) {
      if (PUBLIC_API.current[index].api) {
        const {
          api: {
            api_detail: { params, body_detail, sending_data_type, url, tables },
          },
          id: field_id,
        } = PUBLIC_API.current[index];
        const mapped_tables = {};
        API_PAYLOAD[url] = {};

        for (const index in params) {
          const id = params[index];
          mapping_fields.push(id);
        }

        for (const index in body_detail) {
          const { id, fomular_alias, props } = body_detail[index];

          if (!data_keys.includes(fomular_alias)) {
            mappedData[fomular_alias] = parseTypeWithDefaultValue({
              ...body_detail[index],
              ...props,
            }).result;

            mapping_fields.push(id);
          }
        }

        for (const index in TABLES) {
          const { foreign_keys } = TABLES[index];
          for (const j in foreign_keys) {
            const { field_id, ref_field_id } = foreign_keys[j];
            if (mapping_fields.includes(field_id)) {
              let key, value;
              for (const index in FIELDS) {
                const field = FIELDS[index];
                if (field.id === field_id) {
                  key = field.fomular_alias;
                }
                if (field.id === ref_field_id) {
                  value = field.fomular_alias;
                }
                mappedData[key] = mappedData[value];
              }
            }
          }
        }

        for (const index in tables) {
          const table = TABLES.find((item) => item.id === tables[index]);
          if (table) {
            mapped_tables[table.table_alias] = table;
            API_PAYLOAD[url][table.table_alias] = [];
          }
        }

        for (const k in mapped_tables) {
          const table = mapped_tables[k];

          if (sending_data_type?.[k]?.value === "array") {
            for (const index in data[field_id]) {
              const item = data[field_id][index];
              const payload = {};

              for (const index in body_detail) {
                const { id, fomular_alias, props } = body_detail[index];
                let value =
                  mappedData[fomular_alias] ||
                  item[fomular_alias] ||
                  parseTypeWithDefaultValue({
                    ...body_detail[index],
                    ...props,
                  }).result;

                payload[fomular_alias] = value;
              }
              API_PAYLOAD[url][table.table_alias].push(payload);
            }
          }
        }
      }

      let errors = [];

      for (const field of fields) {
        const { conditions_api = [], conditions = [] } = field;
        if (!data?.[field.id]) continue;

        for (const item of data[field.id]) {
          const SLCXTTCL = item?.SLCXTT;
          const SLCXTT = item?.["4SLCXTT"] || 0;
          const LXH = item?.["lenhXuatHangERP"] || item?.["2MLXH"] || "";

          // gọi API cho từng item
          const requests = conditions_api.map(({ api: value }) => {
            const api = value.value;
            const params = api.params.map((p) =>
              FIELDS.find((f) => f.id === p)
            );

            let url = api.url;
            for (const param of params) {
              url += `/${item[param.fomular_alias]}`;
            }

            return fetch(`${proxy()}${url}`, {
              method: api.api_method.toUpperCase(),
            });
          });

          const responses = await Promise.all(requests);

          const MAPPED_DATA = {};
          for (let i = 0; i < responses.length; i++) {
            const res = responses[i];
            const label = conditions_api[i].label;
            const { data } = await res.json();
            MAPPED_DATA[label] = data;
          }

          const find = MAPPED_DATA?.pp?.[0]?.details?.find(
            ({ delivery_detail_id }) =>
              delivery_detail_id === item?.deliveryDetailId
          );
          const SL_phanphoi = find?.soluongcanxuat || SLCXTTCL;

          for (const condition of conditions) {
            const { conditions: CONDITIONS } = condition;
            for (const cond of CONDITIONS) {
              const result = SLCXTT <= SL_phanphoi && SL_phanphoi > 0;
              if (!result) {
                errors.push(
                  `${LXH} (${find?.delivery_detail_id}) - còn lại: ${SL_phanphoi}`
                );
              }
            }
          }
        }
      }

      // if (errors.length > 0) {
      //   setIsToggleModal({
      //     state: true,
      //     content: errors.join("\n"),
      //   });
      //   return;
      // }

      if (errors.length > 0) {
        setIsToggleModal({
          state: true,
          content: `Số Lượng Tấn Cần Xuất vượt quá số tấn của LXH/LĐĐNB:\n${errors.join(
            "\n"
          )}`,
        });
        return;
      }
    }
    if (Object.values(API_PAYLOAD).length > 0) {
      fetch(`${proxy()}/api/PXK`, {
        method: "POST",
        headers: {
          Authorization: _token,
          "content-type": "application/json",
        },
        body: JSON.stringify({
          ...data,
          pxk_data: { default_field_value: defaultValues, ...data },
          pathname: window.location.pathname.split("/").filter(Boolean)[0],
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          const { message, success } = res;
          if (success) {
            Swal.fire({
              title: lang["success"],
              text: lang["success.add"],
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              setRefreshForm((prev) => prev + 1);
              if (setRefreshPage !== undefined) {
                setRefreshPage((prev) => prev + 1);
              }
              setData([]);
            });
          } else {
            Swal.fire({
              title: lang["failed"],
              text: message,
              icon: "error",
              showConfirmButton: true,
            });
          }
          // } else {
          // if (!emailError && !phoneError && nullCheck(data)) {
          //   fetch(`${proxy()}/ui/${checkIdStr}`, {
          //     method: api_method ? api_method : "POST",
          //     headers: {
          //       Authorization: _token,
          //       "content-type": "application/json",
          //     },
          //     body: JSON.stringify({
          //       ...data,
          //       default_field_value: defaultValues,
          //     }),
          //   })
          //     .then((res) => res.json())
          //     .then(async (res) => {
          //       if (res.content == "403 - Forbidden") {
          //         Swal.fire({
          //           title: lang["fail"],
          //           text: lang["no privileges"],
          //           icon: "error",
          //           showConfirmButton: false,
          //           timer: 1500,
          //         });
          //       }
          //       if (
          //         res.primaryConflict ||
          //         res.foreignConflict ||
          //         res.typeError.status
          //       ) {
          //         handleAPIErrors(res);
          //       } else {
          //         // const requests = [];
          //         // for (const k in API_PAYLOAD) {
          //         //   requests.push(
          //         //     fetch(`${proxy()}${k}`, {
          //         //       method: "PUT",
          //         //       headers: {
          //         //         Authorization: _token,
          //         //         "content-type": "application/json",
          //         //       },
          //         //       body: JSON.stringify(API_PAYLOAD[k]),
          //         //     })
          //         //   );
          //         // }

          //         // await Promise.all(requests);

          //         Swal.fire({
          //           title: lang["success"],
          //           text: lang["success.add"],
          //           icon: "success",
          //           showConfirmButton: false,
          //           timer: 1500,
          //         }).then(() => {
          //           setRefreshForm((prev) => prev + 1);
          //           if (setRefreshPage !== undefined) {
          //             setRefreshPage((prev) => prev + 1);
          //           }
          //         });

          //         const dataSubmit = {
          //           api_id: checkIdStr,
          //           data: data,
          //         };

          //         socket.emit("/dipe-production-new-data-added", dataSubmit);
          //       }
          //     })
          //     .catch((error) => {});
          // } else {
          //   if (emailError)
          //     showError(lang["faild"], lang["error.email_invalid"]);
          //   else if (phoneError)
          //     showError(lang["faild"], lang["error.phone_invalid"]);
          //   else showError(lang["faild"], lang["fail.null"]);
          // }
          // }
        });
    } else {
      for (const field of fields) {
        const { conditions_api = [], conditions = [] } = field;
        if (
          data[field.fomular_alias] &&
          conditions_api.length &&
          conditions.length
        ) {
          const requests = [];
          const MAPPED_DATA = {};
          for (const param of conditions_api) {
            const { api: value } = param;
            const api = value?.value;
            const params = api?.params;
            const mappedParams = [];

            for (const param of params) {
              mappedParams.push(FIELDS.find((item) => item.id === param));
            }
            let url = api.url;
            for (const param of mappedParams) {
              url += `/${data[param?.fomular_alias]}`;
            }

            requests.push(
              fetch(`${proxy()}${url}`, {
                method: api?.api_method.toUpperCase(),
              })
            );
          }
          const response = await Promise.all(requests);
          for (const i in response) {
            const res = response[i];
            const label = conditions_api[i].label;
            const { data } = await res.json();
            MAPPED_DATA[label] = data;
          }
          for (const condition of conditions) {
            const {
              conditions: CONDITIONS,
              isBreak,
              successComponents,
            } = condition;
            for (const cond of CONDITIONS) {
              const {
                left_fields,
                right_fields,
                left_field_position,
                right_field_position,
                operator,
              } = cond;

              const conditionInstance = new Conditions(data, MAPPED_DATA);

              const first_value = conditionInstance.convert(left_fields);
              const second_value = conditionInstance.convert(right_fields);
              const result = conditionInstance.compare(
                { value: first_value, position: left_field_position },
                { value: second_value, position: right_field_position },
                operator.value
              );

              if (isBreak && result) {
                let keysRegex = /\$(variable|from)\([^\)]+\)/g;
                let str = successComponents?.[0]?.value || "";
                setIsToggleModal({
                  state: true,
                  content: str.replace(keysRegex, function (match, p1, p2) {
                    return conditionInstance.convertBuiltInFunc(match);
                  }),
                });
                return;
              }
            }
          }
        }
      }
      // console.log("defaultValues", defaultValues)
      // day la cho ham can check thinh, thinh  viet them event default
      if (!emailError && !phoneError && nullCheck(data)) {
        fetch(`${proxy()}/ui/${checkIdStr}`, {
          method: api_method ? api_method : "POST",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify({ ...data, default_field_value: defaultValues }),
        })
          .then((res) => res.json())
          .then(async (res) => {
            if (res.content == "403 - Forbidden") {
              Swal.fire({
                title: lang["fail"],
                text: lang["no privileges"],
                icon: "error",
                showConfirmButton: false,
                timer: 1500,
              });
            }
            if (
              res.primaryConflict ||
              res.foreignConflict ||
              res.typeError.status
            ) {
              handleAPIErrors(res);
            } else {
              const requests = [];
              for (const k in API_PAYLOAD) {
                requests.push(
                  fetch(`${proxy()}${k}`, {
                    method: "PUT",
                    headers: {
                      Authorization: _token,
                      "content-type": "application/json",
                    },
                    body: JSON.stringify(API_PAYLOAD[k]),
                  })
                );
              }

              await Promise.all(requests);

              Swal.fire({
                title: lang["success"],
                text: lang["success.add"],
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                setData([]);
                setRefreshForm((prev) => prev + 1);
                if (setRefreshPage !== undefined) {
                  setRefreshPage((prev) => prev + 1);
                }
              });

              const dataSubmit = {
                api_id: checkIdStr,
                data: data,
              };

              socket.emit("/dipe-production-new-data-added", dataSubmit);
            }
          })
          .catch((error) => {
            // Xử lý lỗi nếu cần
          });
      } else {
        if (emailError) showError(lang["faild"], lang["error.email_invalid"]);
        else if (phoneError)
          showError(lang["faild"], lang["error.phone_invalid"]);
        else showError(lang["faild"], lang["fail.null"]);
      }
    }
  };

  if (_table) {
    const table_alias = _table?.source?.tables?.[0]?.table_alias;
    const { ct } = auth;
    for (const index in ct) {
      const item = ct[index];
      if (item?.table_alias === table_alias && !item?.["add"]) {
        return null;
      }
    }
  }

  if (!isFetching) {
    if (!fields.length || !tables.length) {
      return <PageNotFound />;
    }
  } else {
    return (
      <img
        width={40}
        className="loading-image"
        src="/images/icon/load.gif"
        alt="Loading..."
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}
      />
      // <div
      //   style={{
      //     width: "100%",
      //     height: "50vh",
      //     display: "flex",
      //     justifyContent: "center",
      //     alignItems: "center",
      //   }}
      // >
      //   <LoadingIcon width="6%" />
      // </div>
    );
  }
  return (
    <div class="midde_cont" onSubmit={handleSubmit}>
      <div class="container-fluid">
        {isModal !== true ? (
          <>
            <div class="row column_title">
              <div class="col-md-12">
                <div class="page_title">
                  <h4 class="ml-1">{lang["data management"]}</h4>
                </div>
              </div>
            </div>
            {/* List table */}
            <div class="row">
              <div class="col-md-12">
                <div
                  class="white_shd full margin_bottom_30"
                  style={{ marginBottom: "0" }}
                >
                  <div class="full graph_head_cus d-flex">
                    <div class="heading1_cus margin_0 ">
                      <h5>
                        <label class="pointer" onClick={() => goToHomePage()}>
                          <a title={lang["back"]}>
                            <i class=" fa fa-chevron-circle-left  mt-3 mb-1 nav-item nav-link"></i>
                          </a>
                          {functions.findPropsNameAddByUrl(
                            page,
                            id_str ? id_str : isUrl
                          )}
                          <i
                            class={` ${
                              functions
                                .findPropsNameAddByUrl(
                                  page,
                                  id_str ? id_str : isUrl
                                )
                                ?.trim() !== "" &&
                              "fa fa-chevron-right ml-2 mr-1"
                            } `}
                          ></i>{" "}
                          {lang["create"]}
                        </label>
                      </h5>
                    </div>
                  </div>
                  <div class="table_section padding_infor_info input_post">
                    <div class="row column1">
                      {isLoading ? (
                        <div class="d-flex justify-content-center align-items-center w-100 responsive-div">
                          <img
                            width={350}
                            className="scaled-hover-target"
                            src="/images/icon/loading.gif"
                          ></img>
                        </div>
                      ) : (
                        <div class="col-md-12">
                          <div
                            className="w-50-pct mg-auto p-1 bg-white input-post"
                            style={{
                              height: "70vh",
                              overflowY: "scroll",
                              overflowX: "hidden",
                            }}
                          >
                            <span className="block text-32-px text-center p-0-5">
                              {api.api_name}
                            </span>
                            {fields.map((field, index) => {
                              if (field?.title?.visible === false) {
                                return null;
                              }
                              if (field?.editor) {
                                return (
                                  <>
                                    <div className="row justify-content-center">
                                      <label for="name" className="col-md-8">
                                        {field?.title?.content ||
                                          field.field_name}
                                        {!field.NULL && (
                                          <span style={{ color: "red" }}>
                                            {" "}
                                            *
                                          </span>
                                        )}
                                      </label>
                                    </div>
                                    <div className="row justify-content-center">
                                      <div
                                        className="col-md-8"
                                        key={refreshForm}
                                      >
                                        <EditorToolbar
                                          id={`toolbar-${index}`}
                                        />
                                        <ReactQuill
                                          key={index}
                                          // value={field?.value || ""}
                                          onChange={(e) =>
                                            changeTrigger(field, e)
                                          }
                                          modules={{
                                            ...modules,
                                            toolbar: {
                                              ...modules.toolbar,
                                              container: `#toolbar-${index}`,
                                            },
                                          }}
                                          formats={formats}
                                        />

                                        {/* <CKEditor
                                          editor={ClassicEditor}
                                          config={{
                                            toolbar: {
                                              items: [
                                                "undo",
                                                "redo",
                                                "|",
                                                "fontfamily",
                                                "fontsize",
                                                "fontColor",
                                                "fontBackgroundColor",
                                                "bold",
                                                "italic",
                                                "insertTable",
                                              ],
                                            },
                                            table: {
                                              contentToolbar: [
                                                "tableColumn",
                                                "tableRow",
                                                "mergeTableCells",
                                                "tableProperties",
                                                "tableCellProperties",
                                              ],
                                            },
                                            plugins: [
                                              Font,
                                              Bold,
                                              Essentials,
                                              Italic,
                                              Mention,
                                              Paragraph,
                                              Undo,
                                              TableToolbar,
                                              Table,
                                            ],
                                            licenseKey: "<YOUR_LICENSE_KEY>",
                                            mention: {
                                              // Mention configuration
                                            },
                                            ui: {
                                              poweredBy: {
                                                position: "inside",
                                                side: "left",
                                                label: "This is",
                                              },
                                            },
                                          }}
                                          data=""
                                          onChange={(event, editor) => {
                                            const data = editor.getData();
                                            changeTrigger(field, data);
                                          }}
                                        /> */}
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                              return (
                                <div key={field.field_id}>
                                  {field.DATATYPE == "PHONE" ? (
                                    <DataPhone
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      onPhoneError={handlePhoneError}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "VARCHAR" ? (
                                    <Varchar
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "CHAR" ? (
                                    <Char
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "TEXT" ? (
                                    <Text
                                      setData={setData}
                                      key={refreshForm}
                                      selectOption={true}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={(...props) => {
                                        changeTrigger(...props, field);
                                      }}
                                      DATA={data}
                                      setDefaultValues={setDefaultValues}
                                      textarea={field.textarea}
                                      refID={refID}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "INT" ||
                                  field.data_type == "BIG INT" ? (
                                    <Int
                                      key={refreshForm}
                                      selectOption={true}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "INT UNSIGNED" ||
                                  field.data_type == "BIG INT UNSIGNED" ? (
                                    <Int
                                      key={refreshForm}
                                      selectOption={true}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      unsigned={true}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "DATE" ? (
                                    <DateInput
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "EMAIL" ? (
                                    <DataEmail
                                      key={refreshForm}
                                      selectOption={true}
                                      readOnly={false}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      onEmailError={handleEmailError}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "TIME" ? (
                                    <TimeInput
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "DATETIME" ? (
                                    <DateTimeInput
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "DECIMAL" ? (
                                    <Decimal
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "DECIMAL UNSIGNED" ? (
                                    <Decimal
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      unsigned={true}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "BOOL" ? (
                                    <Bool
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "FILE" ? (
                                    <FileImage
                                      key={refreshForm}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                    />
                                  ) : null}
                                </div>
                              );
                            })}
                            {/* <div className="m-t-1">
                                                <div className="p-1">
                                                    <div className="button-wrapper">
                                                        <button onClick={submit} className="w-max-content p-0-5 p-l-1 p-r-1 shadow-blur shadow-hover bg-theme-color no-border block text-16-px white pointer shadow-blur shadow-hover">Lưu lại</button>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button  className="w-max-content p-0-5 p-l-1 p-r-1 shadow-blur shadow-hover bg-theme-color no-border block text-16-px white pointer shadow-blur shadow-hover">Quay về</button>
                                                    </div>
                                                </div>
                                            </div> */}

                            {/* <div class="row justify-content-center">
                              <div class="col-md-8">
                                <div class="mt-2 d-flex justify-content-end">
                                  <button
                                    type="submit"
                                    style={{ minWidth: "105px" }}
                                    onClick={() => submit()}
                                    class="btn btn-success mr-2"
                                  >
                                    {lang["btn.create"]}
                                  </button>
                                  <button
                                    type="button"
                                    style={{ minWidth: "105px" }}
                                    onClick={() => goToHomePage()}
                                    data-dismiss="modal"
                                    class="btn btn-danger"
                                  >
                                    {lang["btn.close"]}
                                  </button>
                                </div>
                              </div>
                            </div> */}
                          </div>
                          <div class="row justify-content-center">
                            <div class="col-md-8">
                              <div class="mt-2 d-flex justify-content-end">
                                <button
                                  type="submit"
                                  style={{ minWidth: "105px" }}
                                  onClick={() => submit()}
                                  class="btn btn-success mr-2"
                                >
                                  {/* thinh day la cai nut luu */}
                                  {lang["btn.create"]}
                                </button>
                                <button
                                  type="button"
                                  style={{ minWidth: "105px" }}
                                  onClick={() => goToHomePage()}
                                  data-dismiss="modal"
                                  class="btn btn-danger"
                                >
                                  {lang["btn.close"]}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div class="table_section padding_infor_info p-0">
            <div class="row column1">
              <div class="form-group col-lg-4"></div>
              <div class="col-md-12 col-lg-12">
                <div class="d-flex align-items-center mb-1"></div>
              </div>
              {isLoading ? (
                <div class="d-flex justify-content-center align-items-center w-100 responsive-div">
                  <img
                    width={350}
                    className="scaled-hover-target"
                    src="/images/icon/loading.gif"
                  ></img>
                </div>
              ) : (
                <>
                  <div class="col-md-12">
                    <div className="w-50-pct mg-auto p-1 bg-white">
                      <span className="block text-32-px text-center p-0-5">
                        {api.api_name}
                      </span>
                      {fields.map((field, index) => {
                        if (field?.title?.visible === false) {
                          return null;
                        }
                        if (field?.editor === true) {
                          return (
                            <>
                              <div className="row justify-content-center">
                                <label for="name" className="col-md-8">
                                  {field?.title?.content || field.field_name}
                                  {!field.NULL && (
                                    <span style={{ color: "red" }}> *</span>
                                  )}
                                </label>
                              </div>
                              <div className="row justify-content-center">
                                <div className="col-md-8">
                                  <EditorToolbar id={`toolbar-${index}`} />
                                  <ReactQuill
                                    key={index}
                                    value={field?.value || ""}
                                    onChange={(e) => changeTrigger(field, e)}
                                    modules={{
                                      ...modules,
                                      toolbar: {
                                        ...modules.toolbar,
                                        container: `#toolbar-${index}`,
                                      },
                                    }}
                                    formats={formats}
                                  />
                                  {/* <CKEditor
                                    editor={ClassicEditor}
                                    config={editorConfig}
                                    data=""
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      changeTrigger(field, data);
                                    }}
                                  /> */}
                                </div>
                              </div>
                            </>
                          );
                        }
                        return (
                          <div key={field.field_id}>
                            {field.DATATYPE == "PHONE" ? (
                              <DataPhone
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                                onPhoneError={handlePhoneError}
                              />
                            ) : null}
                            {field.DATATYPE == "VARCHAR" ? (
                              <Varchar
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "CHAR" ? (
                              <Char
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "TEXT" ? (
                              <Text
                                setData={setData}
                                key={refreshForm}
                                selectOption={true}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                DATA={data}
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                                setDefaultValues={setDefaultValues}
                              />
                            ) : null}
                            {field.DATATYPE == "INT" ||
                            field.data_type == "BIG INT" ? (
                              <Int
                                key={refreshForm}
                                selectOption={true}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "INT UNSIGNED" ||
                            field.data_type == "BIG INT UNSIGNED" ? (
                              <Int
                                key={refreshForm}
                                selectOption={true}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                unsigned={true}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "DATE" ? (
                              <DateInput
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "EMAIL" ? (
                              <DataEmail
                                key={refreshForm}
                                selectOption={true}
                                readOnly={false}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                                onEmailError={handleEmailError}
                              />
                            ) : null}
                            {field.DATATYPE == "TIME" ? (
                              <TimeInput
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "DATETIME" ? (
                              <DateTimeInput
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "DECIMAL" ? (
                              <Decimal
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "DECIMAL UNSIGNED" ? (
                              <Decimal
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                unsigned={true}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "BOOL" ? (
                              <Bool
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                            {field.DATATYPE == "FILE" ? (
                              <FileImage
                                key={refreshForm}
                                table={
                                  tables.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                changeTrigger={changeTrigger}
                              />
                            ) : null}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div class="modal-footer w-100">
                    <div class="mt-2 d-flex justify-content-end">
                      <button
                        type="submit"
                        style={{ minWidth: "105px" }}
                        onClick={() => submit()}
                        class="btn btn-success mr-2"
                      >
                        {/* thinh day la cai nut luu */}
                        {lang["btn.create"]}
                      </button>
                      <button
                        type="button"
                        style={{ minWidth: "105px" }}
                        onClick={handleCloseModal}
                        data-dismiss="modal"
                        class="btn btn-danger"
                      >
                        {lang["btn.close"]}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default COMPONENT;
